import React, { useContext } from "react";
import ProductItem from "./ProductItem";
import { StoreContext } from "../../context/StoreContext";
import SearchContext from "../../context/SearchContext";
import { trimAndLowerCase } from "../../util/trimAndLowerCase";
import { decodeHTMLEntities } from "../../util/validate";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';

const ProductList = ({ isListView = false }) => {
  const { data } = useContext(StoreContext);
  const searchCtx = useContext(SearchContext);

  const productsList = data.product_master.filter((value) =>
    decodeHTMLEntities(value.productname)
      .toLowerCase()
      .includes(searchCtx.searchValue.toLowerCase())
  );

  let listOfCategories = productsList.map((item) =>
    decodeHTMLEntities(item.categoryname)
  );

  listOfCategories = listOfCategories
    .sort()
    .filter((v, i) => listOfCategories.indexOf(v) === i);

  return (
    <div className={` ${isListView ? 'list-view' : 'grid-view productlist-wrap'}`}>
      {productsList.length > 0 ? (
        <>
          {isListView ? (
            <Table className="product-table">
              <TableHead className="product-table-head">
              <TableRow className="product-row" >

                  <TableCell
                    className="cell-image table-header-cell"
                  >
                    PHOTO
                  </TableCell>
                  <TableCell
                    className="cell-name table-header-cell"
                  >
                    NAME
                  </TableCell>
                  <TableCell
                    className="cell-price table-header-cell"
                  >
                    PRICE
                  </TableCell>
                  <TableCell
                    className="cell-action table-header-cell"
                  >
                    ACTION
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {listOfCategories.map((cat) => (
                  <React.Fragment key={cat || "others"}>
                    <TableRow>
                      <TableCell colSpan={5} className="category-border" sx={{padding:0}}>
                        {cat ? (
                          <span className="category-label">{cat}</span>
                        ) : (
                          <span className="c-ttl">Others</span>
                        )}
                      </TableCell>
                    </TableRow>
                    {productsList
                      .filter((item) =>
                        decodeHTMLEntities(item.categoryname) === decodeHTMLEntities(cat)
                      )
                      .map((item) => (
                        <ProductItem key={item.id} product={item} isListView={isListView} />
                      ))}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          ) : (
            listOfCategories.map((cat) => (
              <div
                className="category-wrap"
                key={cat || "others"}
                id={cat ? trimAndLowerCase(cat) : "others"}
              >
                {cat ? <span className="c-ttl">{cat}</span> : <span className="c-ttl">Others</span>}
                {productsList
                  .filter((item) => decodeHTMLEntities(item.categoryname) === decodeHTMLEntities(cat))
                  .map((item) => (
                    <ProductItem key={item.id} product={item} isListView={isListView} />
                  ))}
              </div>
            ))
          )}
        </>
      ) : (
        <div className="not-found-text">Couldn’t find items</div>
      )}
    </div>
  );
};

export default ProductList;